import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface InviteTeamState {
    invite: {
        [activityId: string]: ListWrap<number> & ListRequesting;
    };
    inviteMap: {
        [team: number]: InviteTeam.Item;
    };
    inviteDetail: {
        [teamId: number]: InviteTeam.Detail;
    };
    stat: {
        /** 获取邀请的新队长带来的新队员数 */
        [activityId: number]: number;
    };
}

const m: Module<InviteTeamState, RootState> = {
    namespaced: true,
    state: {
        invite: {},
        inviteMap: {},
        inviteDetail: {},
        stat: {},
    },
    mutations: {
        /** 队长邀请排行榜 */
        initInvite(state, { key }) {
            Vue.set(state.invite, key, {
                list: [],
                loaded: false,
                requesting: false,
            });
        },
        concatInvite(state, { key, list }) {
            const ids: number[] = [];
            (list || []).forEach((item: InviteTeam.Item) => {
                if (item && item.id) {
                    Vue.set(state.inviteMap, item.id, item);
                    ids.push(item.id);
                }
            });
            state.invite[key].list = state.invite[key].list.concat(ids);
        },
        setInviteLoaded(state, { key, loaded }) {
            state.invite[key].loaded = loaded;
        },
        setInviteReq(state, { key, req }) {
            state.invite[key].requesting = req;
        },
        setStat(state, { activityId, data }) {
            Vue.set(state.stat, activityId, data);
        },
        setInviteDetail(state, { teamId, detail }) {
            Vue.set(state.inviteDetail, teamId, detail);
        },
    },
    actions: {
        /**
         * 邀请队伍
         */
        async getInvite({ state, commit }, { activityId, nav, offset, count, forceUpdate }) {
            const key = `${activityId}_${nav}`;
            let wrap = state.invite[key];
            if (!wrap || (offset === 0 && forceUpdate)) {
                commit('initInvite', { key });
                wrap = state.invite[key];
            }
            if (wrap.requesting || wrap.loaded) {
                return;
            }
            const end = offset + count;
            const len = wrap.list.length;
            if (end <= len) {
                return;
            }
            if (offset < len) {
                offset = len;
                count = end - offset;
            }
            const params: {
                [key: string]: number | boolean;
            } = {
                offset,
                count,
                activity_id: activityId,
                is_history: nav === 'history' ? 1 : 0,
            };
            commit('setInviteReq', { key, req: true });
            const response = await Vue.axios.get('/api/v1/team/invite_team_list', {
                params,
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const list = rdata.data;
                commit('concatInvite', { key, list });
                if (list.length < count) {
                    commit('setInviteLoaded', { key, loaded: true });
                }
            }
            commit('setInviteReq', { key, req: false });
            return rdata;
        },
        /**
         * 获取邀请的新队长带来的新队员数
         */
        async getInvitNew({ state, commit }, { activityId }) {
            const response = await Vue.axios.get('/api/v1/team/invite_new', {
                params: {
                    activity_id: activityId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setStat', {
                    activityId,
                    data: rdata.data,
                });
            }
            return rdata;
        },
        /**
         * 获得邀请列表
         */
        async getInvitDetail({ state, commit }, { teamId }) {
            commit('setListReq', true);
            const response = await Vue.axios.get('/api/v1/team/invite_team_detail', {
                params: {
                    id: teamId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setInviteDetail', {
                    teamId,
                    detail: rdata.data,
                });
            }
            commit('setListReq', false);
            return rdata;
        },
    },
};

export default m;
